export default "__VITE_ASSET__eac7c4d2__"